<template>
  <div class="flex items-center">
    <div class="w-11 h-6 flex items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out cursor-pointer"
      :class="{ 'bg-green-400': data.is_active }" @click.stop="toggleStatus">
      <div class="bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out"
        :class="{ 'translate-x-5': data.is_active, }">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "AutoresponderStatus",
  data() {
    return {
    }
  },
  methods: {
    toggleStatus() {
        this.$inertia.visit(route('autoresponder.update-status', this.data), { method: 'patch' });
    }
  },
  props: {
    meta: {
      type: Object,
      default: () => { }
    },
    name: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => { }
    },
    click: {
      type: Function,
      default: () => { }
    }
  }
}
</script>

<style scoped>
.contact-table-actions {
  max-width: 40px;
}
</style>
